module.exports = __webpack_public_path__ + "img/tags-big.ad5c580b.svg";